import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export const cn = (...inputs: ClassValue[]) => {
    return twMerge(clsx(inputs));
};

export const getCookie = (name: string) => {
    // No document during a server render; a request rendered on the server is always anonymous.
    if (typeof document === 'undefined') return null;
    const cookies = document.cookie.split(';');
    for (const cookie of cookies) {
        const cookieTrimmed = cookie.trim();
        if (cookieTrimmed.startsWith(name + '=')) {
            return cookieTrimmed.substring(name.length + 1).trim();
        }
    }
    return null;
};
